import "./pa-form-heading.scss";

interface CustomHeadingProps {
  heading: string;
  actionText?: string;
  id?: string;
  onActionClick?: (id: string) => void;
}

function CustomHeading(props: CustomHeadingProps) {
  return (
    <div id="heading" className="heading-section">
      <span>{props.heading}</span>
      {props.actionText && (
        <div className="plus-icon">
          <span
            className="action"
            onClick={() =>
              props.onActionClick && props.onActionClick(props.id!)
            }
          >
            {props.actionText}
          </span>
        </div>
      )}
    </div>
  );
}

export default CustomHeading;
